export { GroupLabel, Label, labelVariants } from "./components/Label/Label"
export type { GroupLabelProps, LabelProps } from "./components/Label/Label"
